import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { apiRequest } from '../services/api';
import { useAuth } from '../auth/AuthContext';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshSession } = useAuth();
  const started = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const code = params.get('code');
    if (!code) { setError('No pudimos validar el acceso. Intentá nuevamente.'); return; }
    apiRequest('/api/auth/oauth/exchange', { method:'POST', auth:false, body:{ code } })
      .then(async () => { await refreshSession(); navigate(params.get('next') || '/client', { replace:true }); })
      .catch(() => setError('El enlace de acceso venció o ya fue utilizado. Volvé a ingresar.'));
  }, [refreshSession, navigate, params]);

  return <Page><Orb/><Mark>nido</Mark><h1>{error ? 'No pudimos completar el acceso' : 'Preparando tu Nido'}</h1><p>{error || 'Verificamos tu identidad y protegemos tu sesión.'}</p>{error&&<button onClick={()=>navigate('/login')}>Volver a ingresar</button>}</Page>;
}
const float=keyframes`50%{transform:translateY(-12px) scale(1.04)}`;
const Page=styled.main`min-height:100vh;background:#c96f4e;color:#fff;display:grid;place-content:center;text-align:center;padding:24px;position:relative;overflow:hidden;h1{font-size:clamp(2.3rem,6vw,4.8rem);line-height:.95;margin:24px auto 14px;max-width:700px}p{font-size:1.1rem;opacity:.9}button{margin:24px auto 0;border:0;border-radius:999px;padding:15px 24px;background:#fff;color:#294f58;font-weight:800;cursor:pointer}`;
const Mark=styled.div`font-size:4.3rem;font-weight:900;letter-spacing:-.08em;animation:${float} 2.4s ease-in-out infinite`;
const Orb=styled.div`position:absolute;width:34vw;height:34vw;border:1px solid rgba(255,255,255,.2);border-radius:50%;left:-12vw;top:-12vw;box-shadow:0 0 0 8vw rgba(255,255,255,.035),0 0 0 16vw rgba(255,255,255,.025)`;
